var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card-title',[_c('div',{class:_vm.classe,staticStyle:{"width":"50%","text-align":"left"}},[_c('h3',{staticClass:"baloo_paaji_bold",attrs:{"data-aos":"fade-down"}},[_vm._v(_vm._s(_vm.titulo))]),_c('div',{staticClass:"progressAnimated",style:('width:' +_vm.width),attrs:{"data-aos":"fade-right"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }